import React from 'react';
import classNames from 'classnames';
import { WordPressEvent } from '../../services/wordpress';

interface EventDetailsProps {
  event: WordPressEvent;
  isExpanded: boolean;
  primColorHue: number;
  showArtistLinks?: boolean;
}

const EventDetails: React.FC<EventDetailsProps> = ({
  event,
  isExpanded,
  primColorHue,
  showArtistLinks = true,
}) => {
  const hasEmbed = event.acf?.link_youtube || event.acf?.link_streaming;

  return (
    <div
      className={classNames('expanded-content', {
        'has-embed': hasEmbed,
      })}
    >
      <div className="streaming">
        {event.acf?.link_youtube && (
          <iframe
            className="embed-content embed-content-youtube"
            width="100%"
            title={`${event.title.rendered} YouTube preview`}
            src={`https://www.youtube.com/embed/${
              event.acf?.link_youtube.split('=')[1]
            }`}
          ></iframe>
        )}
        {!event.acf?.link_youtube &&
          event.acf?.link_streaming && (
            <iframe
              className="embed-content"
              title={`${event.title.rendered} streaming preview`}
              src={`https://open.spotify.com/embed/artist/${
                event.acf?.link_streaming
                  .split('/artist/')[1]
                  .split('?')[0]
              }?utm_source=generator`}
              width="100%"
              height="152"
              loading="lazy"
            ></iframe>
          )}
      </div>
      {showArtistLinks ? (
        <div className="artist-links">
          {event.acf?.link_bandcamp && (
            <a
              href={event.acf?.link_bandcamp}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="/img/bc-logo.png"
                alt="Bandcamp"
                className="social-logo"
                style={{
                  filter: `brightness(0) invert(0.3) sepia(1) saturate(1) hue-rotate(${primColorHue}deg)`,
                }}
              ></img>
            </a>
          )}
          {event.acf?.link_instagram && (
            <a
              href={event.acf?.link_instagram}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="/img/ig-logo.png"
                alt="Instagram"
                className="social-logo"
                style={{
                  filter: `brightness(0) invert(0.3) sepia(1) saturate(1) hue-rotate(${primColorHue}deg)`,
                }}
              ></img>
            </a>
          )}
          {event.acf?.link_youtube &&
            event.acf?.link_streaming && (
              <a
                href={event.acf?.link_streaming}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="/img/sp-logo.png"
                  alt="Spotify"
                  className="social-logo"
                  style={{
                    filter: `brightness(0) invert(0.3) sepia(1) saturate(1) hue-rotate(${primColorHue}deg)`,
                  }}
                ></img>
              </a>
            )}
        </div>
      ) : null}
    </div>
  );
};

export default EventDetails;
